import { GET_ORDER_CONFIRMATION, GET_PAYMENT_DETAILS_FOR_EMAIL, GET_PAYMENT_DETAILS_FOR_DOWNLOAD } from "../../utils/constants"


const initialState = [];

function orderConfirmationReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_ORDER_CONFIRMATION:
            return [...state, payload];
        case GET_PAYMENT_DETAILS_FOR_DOWNLOAD:
            return [...state, payload];
        case GET_PAYMENT_DETAILS_FOR_EMAIL:
            return [...state, payload];
        default:
            return state;
    }
};

export default orderConfirmationReducer;